import getAllTableViewsContainingItemsForFolder from '../../utils/getAllTableViewsContainingItemsForFolder';
import { removeFromMruTableIdList } from '../helpers/tableCache/updateTablesInCache';

export default function removeFolderInListViewStore(folderId: string) {
    // delete all the table views for the current folder
    const tableViewsForCurrentFolder = getAllTableViewsContainingItemsForFolder(
        folderId,
        false /* shouldIncludeSearchTable */
    );
    tableViewsForCurrentFolder.forEach(tableView => removeFromMruTableIdList(tableView.id));
}
